let instance;

export class PropertyDetailsModel {
  static get instance() {
    return instance;
  }
  constructor({data}) {
    instance = this;

    this.data = data;
  }

  getData() {
    return this.data;
  }

  getHeadLines() {
    return (this.data || {}).headline;
  }
}



// WEBPACK FOOTER //
// ./ldp/common_platform/models/property_details.js